import axios from "fetch-api/fetch-api";
import { IShoppingCartV3 } from "interfaces/session/ShoppingCart";

export function getItemsApi() {
  return axios.post<IShoppingCartV3>("/get-shopping-cart-v4");
}
